export default __webpack_public_path__ + "static/media/reparatie_motor_buitenboord.8e589416.svg";